export function matchesNavigationPath(pathname: string, href: string): boolean {
  if (href === "/") {
    return pathname === href;
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}

export type NavItemLike = {
  href: string;
  items?: NavItemLike[];
};

export function collectNavHrefs(items: NavItemLike[]): string[] {
  return items.flatMap((item) => [
    item.href,
    ...collectNavHrefs(item.items ?? []),
  ]);
}

/**
 * A link is active when it matches the path and no other menu href matches
 * with a longer (more specific) path, so `/partners/revenue` does not also
 * light up `/partners`.
 */
export function isNavLinkActive(
  pathname: string,
  href: string,
  competingHrefs: string[] = [],
): boolean {
  if (!matchesNavigationPath(pathname, href)) {
    return false;
  }
  return !competingHrefs.some(
    (other) =>
      other.length > href.length && matchesNavigationPath(pathname, other),
  );
}

export function isNavItemOrChildActive(
  pathname: string,
  item: NavItemLike,
  competingHrefs: string[] = [],
): boolean {
  return (
    isNavLinkActive(pathname, item.href, competingHrefs) ||
    Boolean(
      item.items?.some((child) =>
        isNavItemOrChildActive(pathname, child, competingHrefs),
      ),
    )
  );
}
